export enum UpgradeZbaError {
  SUCCESS = 0,
  // NOT_QUALIFIED = -1,
  // NOT_EKYC = -2,
  // MUST_RE_EKYC = -3,
  NEW_ACCOUNT = -305,
  BLACK_USER = -306,
  MIN_AGE_EXCEED = -300,
  INVALID_STATUS = -307,
  FAIL_FIELD44 = -308,
  USER_NOT_KYC = -309,
  CLONE_USER = -310,
}
